import React, { useState } from 'react';
import { Upload, message, Avatar } from 'antd';
import { LoadingOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import { validateLogo } from '../../utils/validation';
import { getInitials } from '../../utils/helpers';

const LogoUploader = ({ value, onChange, partnerName, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(value);

  const beforeUpload = (file) => {
    const validation = validateLogo(file);

    if (!validation.isValid) {
      validation.errors.forEach((error) => message.error(error));
      return Upload.LIST_IGNORE;
    }

    return false; // Prevent auto upload
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImageUrl(reader.result);
        setLoading(false);
        onChange?.(info.file.originFileObj);
      });
      reader.readAsDataURL(info.file.originFileObj);
    }
  };

  const customRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <div className="logo-uploader">
      <Upload
        name="logo"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={customRequest}
        disabled={disabled}
        accept="image/jpeg,image/png,image/svg+xml"
      >
        {imageUrl ? (
          <img src={imageUrl} alt="logo" style={{ width: '100%', objectFit: 'contain' }} />
        ) : partnerName ? (
          <Avatar size={64} style={{ backgroundColor: '#1890ff' }}>
            {getInitials(partnerName)}
          </Avatar>
        ) : (
          uploadButton
        )}
      </Upload>
      <style jsx>{`
        .logo-uploader :global(.ant-upload.ant-upload-select-picture-card) {
          width: 120px;
          height: 120px;
        }
        .logo-uploader :global(.ant-upload-select-picture-card) {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

export default LogoUploader;
